import { DataTypeActionRegistry } from './services/data-type-action-registry';
import { DataTypeActionRegistryImpl } from './services/impls/data-type-action-registry';
import { bindContributionProvider } from '@patsnap/tahiti-core';
import { DataTypeActionContribution } from './services/data-type-action-contribution';
export function dataTypeActionModule(bind) {
    bindContributionProvider(bind, DataTypeActionContribution);
    bind(DataTypeActionRegistry).to(DataTypeActionRegistryImpl);
}
